import React, { useEffect, useState } from 'react'
import Answers from './Answers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from 'react-quill';
import Uploader from '../../../partial/Uploader';
import PulseLoader from 'react-spinners/PulseLoader';


function Question({question, readOnly, RemoveQuestion, UpdateQuestion}) {
    const {_id} = question
    const [title, setTitle] = useState(question?.title||'')
    const [img, setImg] = useState(question?.img||'')
    const [answerOptions, setAnswerOptions] = useState(question?.answerOptions||[])
    const [open, setOpen] = useState(true)
    useEffect(()=>{
        UpdateQuestion({_id, img, title, answerOptions})
    },[img, title, answerOptions ])
    const onDeleteQuestionClicked = ()=>{
        if(window.confirm('are you sure')){
            RemoveQuestion(_id)
        }
    }
    if(!question || !question._id)   return <PulseLoader color={"#FFF"} />

    const content = (
        <div className='question-pane'>
                <div className="form__title-row">
                    <h2>{_id}</h2>
                    <div className="form__action-buttons">
                    <button type='button'
                className="icon-button"
                title="Delete"
                disabled={readOnly}
                readOnly={readOnly}
                onClick={(onDeleteQuestionClicked)}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
                    <button type='button'
                className="icon-button"
                title="Collapse"
                onClick={()=>setOpen(prev => !prev)}
            >
                <FontAwesomeIcon icon={ (open)? faArrowUp :  faArrowDown } />
            </button>
                    </div>
                </div>            
                <label className="form__label" htmlFor={`${_id}questionTitle`}>
                    שאלה:</label>
                    {readOnly && <ReactQuill
                     theme='bubble'
                    readOnly
                    value={title}
                    
                    ></ReactQuill>}
                 {!readOnly &&   <ReactQuill                  
                    value={title}
                    onChange={setTitle}
                       modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          //[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{size: []}],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />    }
<div style={{display:open?"block":"none"}}>


{!readOnly &&     <Uploader label={'Img'} folderId={'MANAGE_QUESTION'} file={img} setFile={setImg} isImg={true} />}

            <Answers readOnly={readOnly} answerOptions={answerOptions} setAnswerOptions={setAnswerOptions} />

            </div>    

           
            </div>
    )
  return content
}

export default Question